import axios from 'axios';
import { API_BASE_URL } from './api/apiClient';

// 커피챗 섹션 타입 정의
export interface CoffeeChatPerson {
  section_related_person_id: number;
  person_id: number;
  name: string;
  department: string;
  image_url: string | null;
  tags: string[];
}

export interface CoffeeChatSection {
  coffee_chat_section_id: number;
  title: string;
  text: string;
  related_persons: CoffeeChatPerson[];
}

export interface CoffeeChatListResponse {
  code: number;
  status: string;
  message: string;
  data: CoffeeChatSection[];
}

// 커피챗 목록 API
export const fetchCoffeeChatList = async (): Promise<CoffeeChatListResponse> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/ui/home/curations/coffee-chats/list`);
    return response.data;
  } catch (error) {
    /// console.error('커피챗 목록 조회 실패:', error);
    throw error;
  }
};

// 목업 데이터
export const mockCoffeeChatData: CoffeeChatSection[] = [
  {
    coffee_chat_section_id: 1,
    title: "AI 헬스케어 전문가와 함께",
    text: "의료 AI 분야 최고 전문가들과 편안한 대화를 나누며 인사이트를 얻으세요.",
    related_persons: [
      {
        section_related_person_id: 1,
        person_id: 1,
        name: "김민수",
        department: "서울대학교 의과대학",
        image_url: "/images/default_lecturer.jpg",
        tags: ["AI 진단", "의료영상"]
      },
      {
        section_related_person_id: 2,
        person_id: 2,
        name: "이영희",
        department: "연세대학교 의료원",
        image_url: "/images/default_lecturer.jpg",
        tags: ["디지털 헬스케어", "빅데이터"]
      },
      {
        section_related_person_id: 3,
        person_id: 3,
        name: "박철호",
        department: "삼성서울병원",
        image_url: "/images/default_lecturer.jpg",
        tags: ["정밀의료", "AI 신약개발"]
      }
    ]
  }
];
